import axiosConfig from '../modules/axiosConfig'
import utils from '../modules/utils'

const HTTP = axiosConfig.HTTP

const state = {
  code: '',
  loading: false,
  error: '',
  errorDescription: '',
  tpvList: null
}

// getters
const getters = {
  getVisorTPVS: state => state.code,
  isLoadingTPVs: (state) => state.loading,
  getTpvList: state => state.tpvList
}

// actions
const actions = {
  async listVisorTPVS ({ commit, rootState }, params) {
    const config = rootState.appConfig.configFile

    try {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const storageAppToken = sessionStorage.getItem('token')
      const hashToken = utils.SHA256(storageAppData.entidad + storageAppToken + storageAppData.canal)
      let codcomV = ''
      if (params.codcom !== undefined) {
        codcomV = params.codcom
      }
      let body = {}
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: params.avanzar ? params.avanzar : false,
            businesstimeout: '',
            canal: storageAppData.canal,
            claveFin: params.claveFin ? params.claveFin : '',
            claveInicio: params.claveInicio ? params.claveInicio : '',
            entidad: storageAppData.entidad,
            idioma: 'ES',
            indMasDatos: '',
            oficina: '',
            pantPagina: '',
            retroceder: params.retroceder ? params.retroceder : false,
            mainUser: storageAppData.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            codcom: codcomV
          }
        }
      })
      commit('VISORTPVS_REQUEST_STARTED', true)
      const response = await HTTP.post(config.endpoints.visorTPVS, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      if (response.status === 200) {
        switch (response.data.runServiceResponse.return.retorno) {
          case '000':
            commit('SET_TPV_LIST', response.data.runServiceResponse.return.registros)
            return response.data.runServiceResponse.return

          case 210:
            return false

          default:
            commit('HANDLE_ERROR', response.data.runServiceResponse.return.retorno, { root: true })
            return false
        }
      }
      commit('VISORTPVS_REQUEST_FINISHED', false)
      return response
    } catch (error) {
      return error
    }
  },
  loader ({ commit }, actions) {
    commit('SET_LOADER', actions)
  }
}

// mutations
const mutations = {
  'SET_TPV_LIST' (state, payload) {
    state.tpvList = payload
  },
  'SET_LOADER' (state, actions) {
    state.loading = actions.loader === true
    state.isPasswordText = actions.password === true
  },
  'VISORTPVS_REQUEST_STARTED' (state, payload) {
    state.loading = payload
  },
  'VISORTPVS_REQUEST_FINISHED' (state, payload) {
    state.loading = payload
  },
  'VISORTPVS_REQUEST_SUCCEED' (state, payload) {
    const datos = payload
    state.error = false
    state.errorDescription = ''
    state.totalRegistros = datos.totalRegistros
    state.code = datos.totalRegistros > 1 ? datos.registros : Array(datos.registros)
  },
  'VISORTPVS_REQUEST_FAILED' (state, payload) {
    if (payload.retorno === 200) {
      state.errorDescription = 'Error ejecución de servicio'
    } else if (payload.retorno === 220) {
      state.errorDescription = 'Error técnico'
    } else if (payload.retorno === '039') {
      state.errorDescription = 'Sesion expirada'
    } else if (payload.retorno === 210) {
      state.errorDescription = 'No se encontraron datos para los criterios de selección'
    }
    state.error = true
    state.code = ''
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}
